<template>
  <div>
    <template>
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
    </template>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="scss">
@import "@/styles/index.scss";
</style>
